import React from "react";
import { Modal, Button } from "react-bootstrap";
import { 
  FaWallet, 
  FaRupeeSign, 
  FaCalendarAlt, 
  FaUser, 
  FaClock,
  FaCoins,
  FaTrophy,
  FaGift,
  FaHandHoldingUsd,
  FaLock
} from "react-icons/fa";

const WalletModal = ({ show, setShow, editData }) => {
  const {
    fullName = "N/A",
    mobile = "N/A",
    walletBalance = 0,
    depositBalance = 0,
    winningBalance = 0,
    bonusBalance = 0,
    cashbackBalance = 0,
    lockedBalance = 0,
    createdAt = new Date(),
    updatedAt = new Date(),
    transactions = [],
  } = editData || {};

  const handleClose = () => setShow(false);

  // बैलेंस कार्ड्स के लिए कॉन्फ़िगरेशन
  const balanceCards = [
    { 
      label: "Deposit Balance", 
      value: depositBalance, 
      color: "primary", 
      icon: <FaCoins className="me-1" /> 
    },
    { 
      label: "Winning Balance", 
      value: winningBalance, 
      color: "success", 
      icon: <FaTrophy className="me-1" /> 
    },
    { 
      label: "Bonus Balance", 
      value: bonusBalance, 
      color: "warning", 
      icon: <FaGift className="me-1" /> 
    },
    { 
      label: "Cashback Balance", 
      value: cashbackBalance, 
      color: "info", 
      icon: <FaHandHoldingUsd className="me-1" /> 
    },
    { 
      label: "Locked Balance", 
      value: lockedBalance, 
      color: "danger", 
      icon: <FaLock className="me-1" /> 
    },
  ];

  return (
    <Modal show={show} onHide={handleClose} centered size="lg">
      <Modal.Header closeButton className="bg-info text-white">
        <Modal.Title>
          <FaWallet className="me-2" />
          Wallet Details
        </Modal.Title>
      </Modal.Header>
      
      <Modal.Body>
        {/* User Basic Info */}
        <div className="row mb-3">
          <div className="col-md-6">
            <p className="mb-1">
              <strong><FaUser className="me-1" /> Name:</strong> {fullName}
            </p>
          </div>
          <div className="col-md-6">
            <p className="mb-1">
              <strong>Mobile:</strong> {mobile}
            </p>
          </div>
          <div className="col-md-12">
            <p className="mb-1 text-muted" style={{ fontSize: "12px" }}>
              <FaCalendarAlt className="me-1" /> 
              Wallet Created: {new Date(createdAt).toLocaleString()}
            </p>
          </div>
        </div>

        {/* Total Balance - Big Card */}
        <div className="card bg-gradient-success text-white p-3 mb-3" 
             style={{ background: "linear-gradient(135deg, #28a745 0%, #20c997 100%)" }}>
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <h5 className="mb-1">
                <FaWallet className="me-2" /> Total Balance
              </h5>
              <h2 className="mb-0 fw-bold">₹ {Number(walletBalance).toFixed(2)}</h2>
            </div>
            <div className="text-end">
              <small>
                <FaClock className="me-1" />
                Updated: {new Date(updatedAt).toLocaleString()}
              </small>
            </div>
          </div>
        </div>

        {/* Balance Breakdown - All Balances */}
        <div className="row g-2 mb-3">
          {balanceCards.map((item, index) => (
            <div className="col-md-4 col-sm-6" key={index}>
              <div className={`card border-${item.color} h-100 p-2`}>
                <div className="d-flex justify-content-between align-items-center">
                  <small className="text-muted">
                    {item.icon} {item.label}
                  </small>
                  <span className={`text-${item.color} fw-bold`}>
                    ₹ {Number(item.value).toFixed(2)}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Transaction History */}
        {transactions && transactions.length > 0 ? (
          <div className="mt-3">
            <h6 className="border-bottom pb-2">Recent Transactions</h6>
            <div className="table-responsive">
              <table className="table table-sm table-hover">
                <thead className="table-light">
                  <tr>
                    <th>Date</th>
                    <th>Type</th>
                    <th>Amount</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {transactions.slice(0, 5).map((tx, idx) => (
                    <tr key={idx}>
                      <td>{new Date(tx.date).toLocaleDateString()}</td>
                      <td>{tx.type || "N/A"}</td>
                      <td className={tx.amount > 0 ? "text-success" : "text-danger"}>
                        ₹ {tx.amount || 0}
                      </td>
                      <td>
                        <span className={`badge bg-${tx.status === "success" ? "success" : "warning"}`}>
                          {tx.status || "Pending"}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        ) : (
          <p className="text-muted text-center mt-3">
            <FaWallet className="me-1" /> No transactions found.
          </p>
        )}
      </Modal.Body>
      
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default WalletModal;